// react
import React, { Fragment, useState, useEffect } from "react";
// store
import { paymentService } from "../../../../store/services/ServicePayment";
import { LOADING_TIME } from "../../../../store/config";
import { isBeforeCurrentTime } from "../../../../store/services/helpers/dates";
// components
import HeaderTitle from "../../../../components/others/HeaderTitle";
import Loading from "../../../../components/others/Loading";
import OrderedEventsTable from "./OrderedEventsTable";
import { Card, Form, Button, Icon } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import moment from "moment";

// component
const ClientEvents = () => {

    // eslint-disable-next-line
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    // eslint-disable-next-line
    const [isLoading, setIsLoading] = useState(false);
    const [filters, setFilters] = useState({
        from: moment().startOf('month').format("DD.MM.YYYY"),
        to: moment().endOf('month').format("DD.MM.YYYY"),
        activity: null
    })

    const [activityOptions, setActivityOptions] = useState([])

    const [stats, setStats] = useState({
        total: 0,
        upcoming: 0,
        nonUsed: 0,
        refunded: 0,
    })

    const [isMobile, setIsMobile] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("upcoming");

    // fetch data
    async function fetchData() {
        setIsLoading(true);
        let params = `?from=${moment(filters.from, "DD.MM.YYYY").format("YYYY-MM-DD")}&to=${moment(filters.to, "DD.MM.YYYY").format("YYYY-MM-DD")}`;

        const result = await paymentService.getDigitalProductsForUser(params);

        if (result.status === 200) {
            // calculate stats
            const orders = result.response
            orders.sort(function (a, b) {
                if (!a.event || !a.event.starts) return 1;
                if (!b.event || !b.event.starts) return -1;
                let c = new Date(a.event.starts);
                let d = new Date(b.event.starts);
                return d - c;
            });

            let totalRefunded = 0;
            let totalUpcoming = 0;
            let totalNonUsed = 0;
            let options = [];
            let all = orders.length;
            for (let i = 0; i < orders.length; i++) {
                if (!orders[i].event) {
                    orders[i] = { ...orders[i], show: false };
                    all -= 1;
                    continue;
                }
                // create activity list:
                if (!options.some(item => item.value === orders[i].event.activity.id)) {
                    options.push({
                        id: orders[i].event.activity.id,
                        value: orders[i].event.activity.id,
                        text: orders[i].event.activity.name
                    })
                }

                if ((filters.activity === orders[i].event.activity.id || filters.activity === null)) {
                    orders[i] = { ...orders[i], show: true };

                    if (orders[i].is_refunded) {
                        totalRefunded += 1
                    } else if (isBeforeCurrentTime(orders[i].event.starts)) {
                        totalUpcoming += 1
                    } else if (!orders[i].is_used) {
                        totalNonUsed += 1
                    }
                } else {
                    orders[i] = { ...orders[i], show: false };
                    all -= 1;
                }

            }

            setData(orders);
            setActivityOptions(options)
            setStats({
                total: all,
                upcoming: totalUpcoming,
                nonUsed: totalNonUsed,
                refunded: totalRefunded,
            })
        }

        setTimeout(function () {
            setIsLoading(false);
        }, LOADING_TIME);
    }

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        let filtered = data.filter(order => {
            if (!order.show) return false;
            if (selectedFilter === "upcoming") {
                return isBeforeCurrentTime(order.event?.starts) && !order.is_refunded;
            } else if (selectedFilter === "nonUsed") {
                return !isBeforeCurrentTime(order.event?.starts) && !order.is_used && !order.is_refunded;
            } else if (selectedFilter === "refunded") {
                return order.is_refunded;
            } else {
                return true;
            }
        });
        setFilteredData(filtered);
    }, [data, selectedFilter]);

    useEffect(() => {
        const media = window.matchMedia("(max-width: 768px)");
        const handleChange = () => setIsMobile(media.matches);
        handleChange();
        if (media.addEventListener) {
            media.addEventListener("change", handleChange);
        } else {
            media.addListener(handleChange);
        }
        return () => {
            if (media.removeEventListener) {
                media.removeEventListener("change", handleChange);
            } else {
                media.removeListener(handleChange);
            }
        };
    }, []);

    const handleFilter = async () => {
        await fetchData()
        if (isMobile) {
            setShowFilters(false)
        }
    }


    // template
    return (
        <Fragment>
            <HeaderTitle title="Moje termíny" />
            <section>
                {isMobile && (
                    <div style={{ marginBottom: "1rem" }}>
                        <div
                            onClick={() => setShowFilters(!showFilters)}
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "0.85rem 1rem",
                                background: "#f8f9fa",
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                cursor: "pointer",
                                transition: "all 0.2s ease"
                            }}
                        >
                            <div style={{ display: "flex", gap: "0.65rem" }}>
                                <Icon name="sliders horizontal" style={{ margin: 0, fontSize: "1.05rem", color: "#555" }} />
                                <span style={{ fontSize: "0.95rem", fontWeight: 600, color: "#333" }}>Filtrovať</span>
                            </div>
                            <div style={{ display: "flex", gap: "0.6rem" }}>
                                <span style={{ fontSize: "0.85rem", color: "#666", fontWeight: 500 }}>{filters.from} - {filters.to}</span>
                                <Icon name={showFilters ? "chevron up" : "chevron down"} style={{ margin: 0, fontSize: "0.95rem", color: "#555" }} />
                            </div>
                        </div>
                    </div>
                )}

                {(showFilters || !isMobile) && (
                    <Card fluid style={{ borderRadius: "8px", border: "1px solid #e0e0e0", marginBottom: "1rem", boxShadow: "none" }}>
                        <Card.Content style={{ padding: isMobile ? "1rem" : "1.25rem" }}>
                            <Form onSubmit={handleFilter}>
                                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr) 1fr auto", gap: isMobile ? "1rem" : "1rem", alignItems: "end" }}>
                                    <Form.Field style={{ margin: 0 }}>
                                        <label style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555", marginBottom: "0.4rem", display: "block" }}>
                                            Dátum od
                                        </label>
                                        <DateInput
                                            fluid
                                            required
                                            localization="sk"
                                            placeholder="DD.MM.YYYY"
                                            dateFormat="DD.MM.YYYY"
                                            value={filters.from}
                                            onChange={(e, { value }) => setFilters({ ...filters, from: value })}
                                            iconPosition="right"
                                            animation="none"
                                            closable
                                            hideMobileKeyboard
                                        />
                                    </Form.Field>
                                    <Form.Field style={{ margin: 0 }}>
                                        <label style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555", marginBottom: "0.4rem", display: "block" }}>
                                            Dátum do
                                        </label>
                                        <DateInput
                                            fluid
                                            required
                                            localization="sk"
                                            placeholder="DD.MM.YYYY"
                                            dateFormat="DD.MM.YYYY"
                                            value={filters.to}
                                            onChange={(e, { value }) => setFilters({ ...filters, to: value })}
                                            iconPosition="right"
                                            animation="none"
                                            closable
                                            hideMobileKeyboard
                                        />
                                    </Form.Field>
                                    <Form.Field style={{ margin: 0 }}>
                                        <label style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555", marginBottom: "0.4rem", display: "block" }}>
                                            Aktivita
                                        </label>
                                        <Form.Select
                                            fluid
                                            search
                                            clearable
                                            options={activityOptions}
                                            placeholder='Vyberte aktivitu'
                                            value={filters.activity}
                                            onChange={(e, { value }) => {
                                                if (value === "") setFilters({ ...filters, activity: null })
                                                if (value !== "") setFilters({ ...filters, activity: value })
                                            }}
                                        />
                                    </Form.Field>
                                    <Button
                                        fluid
                                        type="submit"
                                        style={{
                                            background: "var(--primary)",
                                            color: "#fff",
                                            borderRadius: "6px",
                                            fontWeight: 600,
                                            padding: "0.85rem 1.5rem",
                                            border: "none",
                                            minWidth: isMobile ? "100%" : "120px"
                                        }}
                                    >
                                        Potvrdiť
                                    </Button>
                                </div>
                            </Form>
                        </Card.Content>
                    </Card>
                )}

                {isLoading
                    ? <Loading />
                    :
                    <>
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: isMobile ? "repeat(2, minmax(0, 1fr))" : "repeat(4, 1fr)",
                                gap: isMobile ? "0.6rem" : "0.85rem",
                                marginBottom: "1rem"
                            }}
                        >
                            <div
                                onClick={() => setSelectedFilter("upcoming")}
                                style={{
                                    borderRadius: "8px",
                                    padding: isMobile ? "0.9rem 0.7rem" : "1.1rem 1.2rem",
                                    border: selectedFilter === "upcoming" ? "1.5px solid var(--primary)" : "0.5px solid #e8e8e8",
                                    background: selectedFilter === "upcoming" ? "#f8f9ff" : "#fff",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease"
                                }}
                            >
                                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                                    <div style={{ color: "#666", fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: 500, marginBottom: "0.45rem", lineHeight: 1.2 }}>Nadchádzajúce / aktívne</div>
                                    <div style={{ fontSize: isMobile ? "1.5rem" : "2rem", fontWeight: 700, color: "#00a651", lineHeight: 1 }}>{stats.upcoming}</div>
                                </div>
                            </div>
                            <div
                                onClick={() => setSelectedFilter("nonUsed")}
                                style={{
                                    borderRadius: "8px",
                                    padding: isMobile ? "0.9rem 0.7rem" : "1.1rem 1.2rem",
                                    border: selectedFilter === "nonUsed" ? "1.5px solid var(--primary)" : "0.5px solid #e8e8e8",
                                    background: selectedFilter === "nonUsed" ? "#f8f9ff" : "#fff",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease"
                                }}
                            >
                                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                                    <div style={{ color: "#666", fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: 500, marginBottom: "0.45rem", lineHeight: 1.2 }}>Nevyužité</div>
                                    <div style={{ fontSize: isMobile ? "1.5rem" : "2rem", fontWeight: 700, color: "#f2711c", lineHeight: 1 }}>{stats.nonUsed}</div>
                                </div>
                            </div>
                            <div
                                onClick={() => setSelectedFilter("refunded")}
                                style={{
                                    borderRadius: "8px",
                                    padding: isMobile ? "0.9rem 0.7rem" : "1.1rem 1.2rem",
                                    border: selectedFilter === "refunded" ? "1.5px solid var(--primary)" : "0.5px solid #e8e8e8",
                                    background: selectedFilter === "refunded" ? "#f8f9ff" : "#fff",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease"
                                }}
                            >
                                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                                    <div style={{ color: "#666", fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: 500, marginBottom: "0.45rem", lineHeight: 1.2 }}>Zrušené / vrátené</div>
                                    <div style={{ fontSize: isMobile ? "1.5rem" : "2rem", fontWeight: 700, color: "#db2828", lineHeight: 1 }}>{stats.refunded}</div>
                                </div>
                            </div>
                            <div
                                onClick={() => setSelectedFilter("all")}
                                style={{
                                    borderRadius: "8px",
                                    padding: isMobile ? "0.9rem 0.7rem" : "1.1rem 1.2rem",
                                    border: selectedFilter === "all" ? "1.5px solid var(--primary)" : "0.5px solid #e8e8e8",
                                    background: selectedFilter === "all" ? "#f8f9ff" : "#fff",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease"
                                }}
                            >
                                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                                    <div style={{ color: "#666", fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: 500, marginBottom: "0.45rem", lineHeight: 1.2 }}>Všetko</div>
                                    <div style={{ fontSize: isMobile ? "1.5rem" : "2rem", fontWeight: 700, color: "#333", lineHeight: 1 }}>{stats.total}</div>
                                </div>
                            </div>
                        </div>
                        <OrderedEventsTable orders={filteredData} setOrders={setData} isLoading={isLoading} />
                    </>
                }
            </section>
        </Fragment>
    );
};

export default ClientEvents;
